import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomToastService } from '../pages/custom-toast/custom-toast.service';

@Injectable({
  providedIn: 'root',
})
export class AccessDeniedService {
  constructor(private customToastService: CustomToastService) {}

  isAccessDenied(error: HttpErrorResponse) {
    try {
      let errorMessage = '';
      if (typeof error?.error === 'string') {
        errorMessage = error?.error;
      } else {
        try {
          errorMessage =
            error?.error?.message || JSON.parse(error?.error).message;
        } catch (error) {
          error = {};
        }
      }

      if (
        (error.status === 500 || error.status === 403) &&
        (errorMessage === 'Access is denied' ||
          errorMessage === 'Unauthorized Access')
      ) {
        this.customToastService.show({
          title: 'Access is forbidden',
          content: 'Please contact your administrator for more details',
          duration: 5000,
          status: 'error',
        });
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }
}
